module.exports = __webpack_public_path__ + "img/qrcode.a7a189d3.png";